export function existingSystemsHaveInventory(
  existingSystems: ReadonlyArray<{ components: readonly unknown[] }>
): boolean {
  return existingSystems.some((system) => system.components.length > 0);
}
